module.exports = __webpack_public_path__ + "media/whistle.33e22457.mp3";